import script from "./GoalsCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoalsCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./GoalsCheckbox.vue?vue&type=style&index=0&id=caf2038c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caf2038c"]])

export default __exports__